import mixpanel from 'mixpanel-browser';

/**
 * Configuration options for Mixpanel initialization
 */
export interface MixpanelConfig {
  token: string;
  environment: string;
}

/**
 * Initialize Mixpanel analytics
 * @param config - Mixpanel configuration
 */
export function initializeMixpanel(config: MixpanelConfig): void {
  mixpanel.init(config.token, {
    debug: config.environment === 'development',
    track_pageview: true,
    persistence: 'localStorage',
  });
}

/**
 * Get the Mixpanel instance for direct access
 */
export { mixpanel };
